import { ICRSCriminalTenantData, ICRSEvictionTenantData, ICRSTenantData } from 'interfaces/application'
import { IProperty } from 'interfaces/property'

export const STRIPE_PUBLISHABLE_KEY: string = process!.env!.STRIPE_PUBLISHABLE_KEY!

export const refererSource: string[] = [
  'Apartments.com',
  'Craigslist',
  'Facebook Group',
  'Facebook Marketplace',
  'Facebook Ad',
  'Livehomeroom.com',
  'Realtor.com',
  'RentPath',
  'Roomster',
  'Zumper',
  'Other'
]

export enum EApplicationStepBar {
  APPLICATION_INFORMATION = 0,
  PAYMENT = 1,
  COMPLETE_SCREENING = 2,
  COMPLETED = 3
}

export enum EApplicationCompletedStateV2 {
  PHONE_NUMBER_SUBMITTED = 'Phone number submitted',
  OTP_VERIFIED = 'OTP verified',
  BASIC_INFORMATION_SUBMITTED = 'Basic information submitted',
  PAYMENT_SUBMITTED = 'Background information and most recent address submitted',
  COMPLETE_SCREENING_SUBMITTED = 'Drivers license, fee payment and paystub uploader submitted',
  FULL_APPLICATION_COMPLETED = 'Full application completed',
  BLANK = ''
}

export enum EApplicationCompletedStateV3 {
  PHONE_NUMBER_SUBMITTED = 'Phone number submitted',
  BASIC_INFORMATION_SUBMITTED = 'Basic information submitted',
  PAYMENT_SUBMITTED = 'Payment submitted',
  COMPLETE_SCREENING_SUBMITTED = 'Complete screening submitted',
  FULL_APPLICATION_COMPLETED = 'Full application completed',
  BLANK = ''
}

export enum EDriverLicenseTypeEnum {
  ACCEPT = 'accept',
  REVIEW = 'review',
  REJECT = 'reject'
}

export enum EBottomButtonValue {
  BACK = 'Back',
  CONTINUE = 'Continue',
  SUBMIT = 'Submit Application',
  COMPLETE = 'Complete'
}

export const DESKTOP_CONTAINER_WIDTH: string = '600px'
export const TABLET_CONTAINER_WIDTH: string = '736px'

export interface IApplicationFormModalV3Props {
  isOpen: boolean
  onClose: () => void
  phoneNumber: string
  buildiumUnitId: number
  buildiumPropertyId?: number
  address?: string
  isEntireHouse?: boolean
  isContinueApplying?: boolean
  houseApplicationId?: string
  houseDetail: IProperty
}

export interface IBerbixTransactionResponse {
  refreshToken: string
  hostedUrl: string
}

export interface IBerbixTransaction {
  id: string
  entity?: string
  transactionId: number
  action?: string
  driverLicenseFrontPhotoUrl?: string
  driverLicenseBackPhotoUrl?: string
  createdAt: Date
  updatedAt: Date
  completedAt: Date
  customerUid?: string
  isDuplicated?: boolean
  dashboardUrl?: string
}

// INFO: mock data using for testing CRS check on SandBox
export const TEST_CRS_EMAIL_SUB: string = '.test-crs@yopmail.com'
export const TEST_CRS_CREDIT_SCORE_MOCK_DATA: ICRSTenantData = {
  firstName: 'daisy',
  lastName: 'oogrd',
  ssn: '666268141',
  dob: '1969-01-27',
  city: 'HONOLULU',
  state: 'HI',
  phone: '0000000000'
}

export const TEST_CRS_CRIMINAL_MOCK_DATA: ICRSCriminalTenantData = {
  last: 'Consumer',
  first: 'Jonathan',
  dob: '01-01-1982',
  ssn: '666-44-3321',
  city: 'Cottonwood',
  state: 'CA',
  zip: '91502'
}

export const TEST_CRS_EVICTION_MOCK_DATA: ICRSEvictionTenantData = {
  last: 'Consumer',
  first: 'Jonathan',
  dob: '01-01-1982',
  ssn: '666-44-3321',
  houseNumber: '1803',
  streetName: 'Norma',
  city: 'Cottonwood',
  state: 'CA',
  zip: '91502'
}

export const DOCUSIGN_LOADING_PAGE_URL: string = `${process.env.FE_BASE_URL}/docusign-loading`

export const SECURITY_DEPOSIT: number = 350

export const APPLICATION_FEE: number = 35
export const APPLICATION_TEST_FEE: number = 0.5

export const PAYSTUBS_REQUIRED_QUANTITY: number = 3
